import { render, staticRenderFns } from "./ProductStructureBuilder.vue?vue&type=template&id=2866b98c&scoped=true&"
import script from "./ProductStructureBuilder.vue?vue&type=script&lang=js&"
export * from "./ProductStructureBuilder.vue?vue&type=script&lang=js&"
import style0 from "./ProductStructureBuilder.vue?vue&type=style&index=0&id=2866b98c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2866b98c",
  null
  
)

export default component.exports